import { Zap } from "lucide-react";

export default function Marquee({ items, duration = 45, className = "" }) {
  const Sequence = ({ hidden }) => (
    <div
      className="flex shrink-0 items-center"
      aria-hidden={hidden || undefined}
    >
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-zinc-500 px-6 whitespace-nowrap">
            {item}
          </span>
          <Zap className="h-3.5 w-3.5 text-volt shrink-0" strokeWidth={2.5} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`overflow-hidden border-y border-black/10 bg-surface py-5 ${className}`}
      style={{ "--marquee-duration": `${duration}s` }}
      data-testid="marquee"
    >
      <div className="marquee-track">
        <Sequence />
        <Sequence hidden />
      </div>
    </div>
  );
}
